import type { Policy } from "@/types";

/**
 * True when the policy carries an aggregate specific deductible (#3302).
 *
 * Mirrors the backend's `isASDEnabled` (worker-api `orchestrator.go`) exactly: the
 * flag AND a positive amount. The backend deliberately falls back to the non-ASD path
 * (with a warning) when the flag is set but the amount is zero or null, so gating on
 * the flag alone would show ASD columns for a policy the engine never allocated
 * against — every row a dash, which is worse than hiding the columns.
 *
 * Gates on the flag rather than on the presence of `asd_tracking`: tracking is absent
 * until the engine first runs, and an ASD policy with no document loads yet is still
 * an ASD policy.
 *
 * Lives in utils rather than alongside `AggSpecCorridorBanner` so the export path and
 * its tests can gate on ASD without importing a React component (and its MUI graph).
 */
export const isAggregateSpecificPolicy = (policy?: Policy): boolean => {
  const sb = policy?.specific_benefit;
  return sb?.is_aggregate_specific_deductible === true && (sb?.aggregate_specific_deductible ?? 0) > 0;
};
